export type WebContentGroup = 'marketing' | 'app'

// Exact pathnames that are top-of-funnel / informational, not app usage.
const MARKETING = new Set<string>([
  '/', '/welcome', '/login', '/signup', '/forgot-password',
  '/auth/action', '/pricing', '/privacy-policy', '/terms-of-service', '/contact',
])

/** Classify a web pathname as marketing-site vs app usage for GA4 content_group. */
export function webContentGroupForPath(pathname: string): WebContentGroup {
  return MARKETING.has(pathname) ? 'marketing' : 'app'
}
